import styled from 'styled-components';

import { COLORS, SPACE } from '../../../../theme/tokens';
import { Button, Text } from '../../../../components';

/** The dialog body: the consequences, then the typed confirmation. */
export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

/** The dialog's body lines: they explain the title's question, so muted (one strong colour per
 *  block, see mailbox.styles.ts), not the modal's inherited heading ink. */
export const Line = styled(Text)`
  display: block;
  font-size: 14px;
  line-height: 1.5;
  color: ${COLORS.textMuted};
`;

/** The confirm button: the shared primary pill in the DANGER fill rather than the product orange,
 *  since this one destroys something. The ink stays the primary's dark ink (5.7:1 on the red;
 *  white would be 3.3:1 and miss AA at this size). Same box, same glow, same disabled treatment:
 *  only the colour says what kind of action it is. */
export const DeleteButton = styled(Button)`
  background: ${COLORS.danger};
  border-color: ${COLORS.danger};
  color: ${COLORS.ctaSolidText};
`;
